<p-card header="Cliente" [style]="{ width: '100%' }" *ngIf="clienteID">
    <div class="customer-card">
        <div class="customer-header">
            <img src="https://via.placeholder.com/50" alt="Profile" class="profile-img" />
            <span class="customer-name">{{pessoa.nome}}</span>
        </div>
        <hr />
        <div class="customer-info">
            <div class="info-item">
                <i class="pi pi-shopping-cart icon"></i>
                <span>3 Orders</span>
            </div>
            <div class="info-item text">
                <i class="pi pi-wallet icon"></i>
                <span>-4110 $</span>
            </div>
        </div>
        <hr />
        <div class="contact-info">
            <strong>Contact info</strong>
            <div class="text">
                <i class="pi pi-phone icon"></i> {{pessoa.telefone}}
            </div>
            <div class="text">
                <i class="pi pi-envelope icon"></i> {{pessoa.email}}
            </div>
        </div>
        <hr />
        <div class="address-info">
            <strong>Endereço</strong>
            <div class="text">Estado: {{pessoa.estadoNome}}</div>
            <div class="text">Cidade: {{pessoa.cidadeNome}}</div>
            <div class="text">Endereço: {{pessoa.endereco}}</div>
        </div>
    </div>
</p-card>
